import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "arrow-down",
  "use": "arrow-down-usage",
  "viewBox": "0 0 21 21",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 21 21\" id=\"arrow-down\"><title>arrow down</title><g id=\"arrow-down__visibility\"><g id=\"arrow-down_Layer_8-2\" data-name=\"Layer 8\"><path d=\"M10.5,14.21,5.15,8.85a.502.502,0,0,1,.71-.71l4.65,4.65,4.65-4.65a.502.502,0,0,1,.71.71Z\" /></g></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/arrow-down.svg
// module id = /7LY
// module chunks = 4